<template>
  <div class="illustration-codes-content" id="identidade-visual-ilustracao-codigos" data-search-anchor>
    <div class="illustration-codes-wrapper">
      <h1 class="illustration-codes-title-span">{{ codesTitleSpan }}</h1>
      <h1 class="illustration-codes-title">{{ codesTitle }}</h1>
    </div>

    <div class="description-illustration-codes-wrapper">
      <div>
        <div class="illustration-codes-icon-wrapper1">
        <p class="illustration-codes-description">{{ codesDescription1 }}</p>
      </div>
      <div class="illustration-codes-icon-wrapper-nao-esqueca">
        <p class="nao-esqueca" style="margin-bottom: 0;">{{ codesDescription2 }}</p>
        <div class="illustration-nao-esqueca">
          <IconCancel />
          <p class="illustration-codes-description-nao-esqueca3">{{ codesDescription3 }}</p>
        </div>
      </div>

      </div>
      
    </div>
    <div class="illustration-code-palette-wrapper">
      <div v-for="(row, rowIndex) in colorRows" :key="'row-' + rowIndex" class="illustration-code-color-row">
        <div v-for="(item, i) in row" :key="'color-' + rowIndex + '-' + i" class="illustration-code-color-block"
          :class="[item.textColor, { 'with-border': item.hex.toLowerCase() === '#ffffff' }]"
          :style="{ backgroundColor: item.hex }">
          <strong class="illustration-code-color-title">{{ item.title }}</strong>
          <p class="illustration-code-color-text" v-html="item.text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { applyHighlightAndWatch } from '@/core/searchHighlight'

@Component({ components: { IconCancel } })
export default class IllustrationCodesSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get codesTitleSpan(): string {
    return this.getElementTitle(5, 0)
  }

  get codesTitle(): string {
    return this.getElementText(5, 0)
  }

  get codesDescription1(): string {
    return this.getElementText(5, 1)
  }

  get codesDescription2(): string {
    return this.getElementText(5, 2)
  }

  get codesDescription3(): string {
    return this.getElementText(5, 3)
  }

  get ImageSrc(): string {
    return this.getElementMedia(5, 4)
  }

  get colorRows() {
    const indexes = Array.from({ length: 18 }, (_, i) => i + 5)
    const chunked = []
    for (let i = 0; i < indexes.length; i += 6) {
      chunked.push(indexes.slice(i, i + 6).map((index) => this.getColorBlock(index)))
    }
    return chunked
  }

  getColorBlock(index: number) {
    const text = this.getElementText(5, index)
    return {
      title: this.getElementTitle(5, index),
      text: this.formatColorText(text),
      hex: text.match(/HEX\s*(#[A-Fa-f0-9]{6})/)?.[1] || '#ffffff',
      textColor: this.getTextColorByIndex(index)
    }
  }

  formatColorText(text: string): string {
    return text
      .replace(/Pantone\s*([^\n]+)/, '<strong>Pantone</strong><br>$1<br><br>')
      .replace(/HEX\s*([^\n]+)/, '<strong>HEX</strong><br>$1<br><br>')
      .replace(/RGB\s*([^\n]+)/, '<strong>RGB</strong><br>$1<br><br>')
      .replace(/CMYK\s*([^\n]+)/, '<strong>CMYK</strong><br>$1')
  }

  getTextColorByIndex(index: number): string {
    const whiteTextIndexes = [5, 6, 7, 9, 11, 12, 13, 17, 18, 19, 22]
    return whiteTextIndexes.includes(index) ? 'text-white' : 'text-black'
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
    
    const query = (this.$route.query.q as string) || ''
    if (query) {
      this.$nextTick(() => {
        applyHighlightAndWatch(query)
      })
    }
  }
}
</script>

<style lang="scss">
.illustration-codes-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-codes-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.illustration-codes-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-codes-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-illustration-codes-wrapper {
  position: relative;

  display: grid;
  grid-template-columns: 50% 50%;
}

.illustration-codes-icon-wrapper1 {
  display: flex;
}

.illustration-codes-icon-wrapper {
  display: flex;
  align-items: center;
}

.illustration-codes-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
 
  width: 430px;
}

.illustration-codes-card-item {
  position: relative;
  bottom: 0;

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.nao-esqueca,
.illustration-codes-description-nao-esqueca3 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left; 
  width: 378px;  
}

.illustration-codes-description-nao-esqueca3 {
  padding-left: 7px;
}

.illustration-codes-icon-wrapper-nao-esqueca {
  display: flex;
  flex-direction: column;  
}

.illustration-nao-esqueca {
  display: flex;
  align-items: center;
}

.illustration-code-color-palette-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.illustration-code-color-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.illustration-code-color-block {
  padding: 1rem;
  border-radius: 8px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-family: GlobotipoCorporativaTextosRegular;
}

.illustration-code-color-block.with-border {
  border: 1px solid black;
}

.illustration-code-color-title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.illustration-code-color-text {
  font-size: 12px;
  line-height: 1.1;
}

.illustration-code-text-white {
  color: #fff;
}

.illustration-code-text-black {
  color: #000;
}
</style>
